import OnDemandDevelopers from "../on-demand-developers";
import ProjectByEquity from "../project-by-equity";
import FullProjectDevelopment from "../full-project-development";
import WhatServices from "../what-services";
import Confirmation from "../confirmation";
import NavBar from "../nav-bar";
// import Intro from "../Intro";
import OurServices from "../our-services";
// import SeeOurWork from "../see-our-work";
// import ImpactAcrossIndustries from "../impact-across-industries";
// import WhatMakeUsDifferent from "../what-make-us-different";
// import WhatOurClientSays from "../what-our-client-says";
// import MeetOurTeam from "../meet-our-team";
// import AboutUs from "../about-us";
import Grid from "@mui/material/Grid/Grid";
import {
    // CustomLabelLargeBold,
    // CustomLabelLargeBoldRedHat, CustomLabelLargeServiceDetailsBold,
    CustomLabelMediumBold,
    CustomLabelMediumRegular, 
    // CustomLabelMediumRegularDetailsInto,
    // CustomLabelMediumRegularInto,
    // CustomLabelMediumRegularRedHatInto,
    CustomLabelMediumSmallBold,
    CustomLabelRegularLargeMedium,
    // CustomLabelRegularMedium,
    // CustomLabelSmallBold,
    // CustomLabelSmallMediumRegular,
    // CustomLabelSmallRegular,
    // CustomLabelXSmallRegular
} from "../common/CustomLabel";
import Box from "@mui/material/Box/Box";
import IPHONE151 from "../../assets/images/iPhone 15 Pro-1.png";
import ContactUs from "../contact-us";
import Footer from "../footer";
import React, {useRef, useState} from "react";
// import {useMediaQuery} from "@mui/material";
// import createTheme from "@mui/material/styles/createTheme";
import IntroDetails from "../intro-details";
// import WorkDetails from "../work-details";
// import PROJECT1 from "../../assets/images/project_1.png";
// import PROJECT2 from "../../assets/images/project2.png";
// import PROJECT3 from "../../assets/images/project3.png";
// import PROJECT_DETAILS from "../../assets/images/project-details.png";
// import ListItem from "@mui/material/ListItem/ListItem";
// import ListItemText from "@mui/material/ListItemText/ListItemText";
// import List from "@mui/material/List/List";
// import {motion, AnimatePresence} from 'framer-motion';
// import BLOG_IMAGE from "../../assets/images/blog.png";


// const theme = createTheme({
//     breakpoints: {
//         values: {
//             xs: 0,
//             sm: 710,
//             md: 950,
//             lg: 1300,
//             xl: 1350,
//         },
//     },
// });


const TermsCondition = () => {

    const [isMenuClicked, setIsMenuClicked] = useState(false)

    // const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    const [showFullProject, setShowFullProject] = useState(false);
    const [showOnDemandDevelopers, setShowOnDemandDevelopers] = useState(false);
    const [showProjectByEquity, setShowProjectByEquity] = useState(false);
    const [showWhatServices, setShowWhatService] = useState(false);
    const [showConfirmation, setShowConfirmation] = useState(false);


    const serviceRef = useRef(null);
    const portfolioRef = useRef(null);
    const testimonalsRef = useRef(null);
    const partnersRef = useRef(null);
    const contactUsRef = useRef(null);


    // const Details = {
    //     img: PROJECT_DETAILS,
    //     date:"July 8, 2023",
    //     title: "Creating Memorable User Experiences: Design Principles for Success",
    //     description: "An e-commerce platform promoting sustainable products and eco-friendly living. Features include user-friendly navigation, product reviews, and secure payment options.",
    //     tags: ["UI/UX Design", "Front-end Development", "Website"]
    // };

    // const WorkList = {
    //     work: [
    //         {
    //             img: PROJECT1,
    //             title: "EcoVibes Marketplace",
    //             description: "An e-commerce platform promoting sustainable products and eco-friendly living. Features include user-friendly navigation, product reviews, and secure payment options.",
    //             tags: ["UI/UX Design", "Front-end Development", "Website"]
    //         },
    //         {
    //             img: PROJECT2,
    //             title: "HealthLink App",
    //             description: "A mobile application connecting users with healthcare professionals for virtual consultations and medical advice. Features include appointment scheduling, symptom checker, and secure messaging.",
    //             tags: ["UI/UX Design", "Front-end Development", "Website"]
    //         },
    //         {
    //             img: PROJECT3,
    //             title: "TechSavvy Education Portal",
    //             description: "An online learning platform offering courses in technology, coding, and digital skills. Features include interactive lessons, progress tracking, and instructor-led webinars.",
    //             tags: ["UI/UX Design", "Front-end Development", "Website"]
    //         },
    //         {
    //             img: PROJECT1,
    //             title: "EcoVibes Marketplace",
    //             description: "An e-commerce platform promoting sustainable products and eco-friendly living. Features include user-friendly navigation, product reviews, and secure payment options.",
    //             tags: ["UI/UX Design", "Front-end Development", "Website"]
    //         },
    //         {
    //             img: PROJECT2,
    //             title: "HealthLink App",
    //             description: "A mobile application connecting users with healthcare professionals for virtual consultations and medical advice. Features include appointment scheduling, symptom checker, and secure messaging.",
    //             tags: ["UI/UX Design", "Front-end Development", "Website"]
    //         }

    //     ]
    // }


    return (
        <Grid style={{width: "100vw", height: "100vh", overflowX: "hidden",}}>

            {
                showOnDemandDevelopers && <OnDemandDevelopers setShowOnDemandDevelopers={setShowOnDemandDevelopers}
                                                              setShowConfirmation={setShowConfirmation}
                />
            }

            {
                showProjectByEquity && <ProjectByEquity setShowProjectByEquity={setShowProjectByEquity}
                                                        setShowConfirmation={setShowConfirmation}/>
            }


            {
                showFullProject && <FullProjectDevelopment setShowFullProject={setShowFullProject}
                                                           setShowConfirmation={setShowConfirmation}/>
            }


            {
                showWhatServices &&
                <WhatServices setShowWhatService={setShowWhatService} setShowFullProject={setShowFullProject}
                              setShowProjectByEquity={setShowProjectByEquity}
                              setShowOnDemandDevelopers={setShowOnDemandDevelopers}/>
            }


            {
                showConfirmation && <Confirmation setShowConfirmation={setShowConfirmation}/>
            }

            <Grid container sx={{position: "relative"}}>
                <NavBar isMenuClicked={isMenuClicked} serviceRef={serviceRef} portfolioRef={portfolioRef}
                        testimonalsRef={testimonalsRef} partnersRef={partnersRef} setIsMenuClicked={setIsMenuClicked}
                        contactUsRef={contactUsRef}
                        setShowWhatService={setShowWhatService}/>


                <IntroDetails title={"Terms and Conditions"}
                              hideSearch={true}
                              description={""}
                />


                <Grid container justifyContent={"center"}>
                <Grid container item xs={11} direction={"column"}>
                    <Grid item sx={{marginTop: "40px"}}>
                        <CustomLabelMediumSmallBold text={"Introduction"} color={"#5E17EB"}/>
                    </Grid>
                    <Grid item sx={{marginTop:"5px"}}>
                        <CustomLabelRegularLargeMedium normal={true} color={"#333333"}
                                                       text={"Welcome to OSTRYX Private Limited. By accessing or using our services, you agree to comply with and be bound by the following terms and conditions."}
                        />
                    </Grid>


                    <Grid item sx={{marginTop: "40px"}}>
                        <CustomLabelMediumSmallBold text={"Services Provided"} color={"#5E17EB"}/>
                    </Grid>
                    <Grid item sx={{marginTop:"5px"}}>
                        <CustomLabelRegularLargeMedium normal={true} color={"#333333"}
                                                       text={"We provide software development services including on-demand developer hiring, full project development, and project-by-equity solutions."}
                        />
                    </Grid>


                    <Grid item sx={{marginTop: "40px"}}>
                        <CustomLabelMediumSmallBold text={"Payment and Equity Agreements"} color={"#5E17EB"}/>
                    </Grid>
                    <Grid item sx={{marginTop:"5px"}}>
                        <CustomLabelRegularLargeMedium normal={true} color={"#333333"}
                                                       text={"Payment terms will be defined before the commencement of any project or service."}
                        />
                        <CustomLabelRegularLargeMedium normal={true} color={"#333333"}
                                                       text={"Equity agreements will be clearly defined in a separate contract, including the percentage of equity and terms of ownership, if applicable."}
                        />
                    </Grid>

                    <Grid item sx={{marginTop: "40px"}}>
                        <CustomLabelMediumSmallBold text={"Intellectual Property"} color={"#5E17EB"}/>
                    </Grid>
                    <Grid item sx={{marginTop:"5px"}}>
                        <CustomLabelRegularLargeMedium normal={true} color={"#333333"}
                                                       text={"Ownership of the developed product will be transferred to the client upon full payment, except for project-by-equity arrangements where ownership is shared as per the equity agreement."}
                        />
                    </Grid>

                    <Grid item sx={{marginTop: "40px"}}>
                        <CustomLabelMediumSmallBold text={"Confidentiality"} color={"#5E17EB"}/>
                    </Grid>
                    <Grid item sx={{marginTop:"5px"}}>
                        <CustomLabelRegularLargeMedium normal={true} color={"#333333"}
                                                       text={"Both parties agree to maintain the confidentiality of proprietary information exchanged during the course of the project."}
                        />
                    </Grid>

                    <Grid item sx={{marginTop: "40px"}}>
                        <CustomLabelMediumSmallBold text={"Limitation of Liability"} color={"#5E17EB"}/>
                    </Grid>
                    <Grid item sx={{marginTop:"5px"}}>
                        <CustomLabelRegularLargeMedium normal={true} color={"#333333"}
                                                       text={"OSTRYX Private Limited is not liable for any indirect or consequential damages arising out of the use of our services."}
                        />
                    </Grid>

                    <Grid item sx={{marginTop: "40px"}}>
                        <CustomLabelMediumSmallBold text={"Termination"} color={"#5E17EB"}/>
                    </Grid>
                    <Grid item sx={{marginTop:"5px"}}>
                        <CustomLabelRegularLargeMedium normal={true} color={"#333333"}
                                                       text={"We reserve the right to terminate services if the client breaches any terms or fails to make payments as agreed."}
                        />
                    </Grid>

                    <Grid item sx={{marginTop: "40px"}}>
                        <CustomLabelMediumSmallBold text={"Governing Law"} color={"#5E17EB"}/>
                    </Grid>
                    <Grid item sx={{marginTop:"5px"}}>
                        <CustomLabelRegularLargeMedium normal={true} color={"#333333"}
                                                       text={"These terms are governed by the laws of the State of Texas, USA."}
                        />
                    </Grid>

                    <Grid item sx={{marginTop: "40px"}}>
                        <CustomLabelMediumSmallBold text={"Changes to Terms and Conditions"} color={"#5E17EB"}/>
                    </Grid>
                    <Grid item sx={{marginTop:"5px"}}>
                        <CustomLabelRegularLargeMedium normal={true} color={"#333333"}
                                                       text={"We may update these terms from time to time. Clients will be notified of any changes."}
                        />
                    </Grid>

                </Grid>
                </Grid>

            </Grid>



            <OurServices serviceRef={serviceRef} setShowOnDemandDevelopers={setShowOnDemandDevelopers}
                         setShowWhatService={setShowWhatService}
                         setShowFullProject={setShowFullProject}
                         setShowProjectByEquity={setShowProjectByEquity}/>


            <Grid container sx={{paddingBottom: {xs: "30px", md: "50px"}}} justifyContent={"center"}>

                <Grid item container justifyContent={"center"} sx={{marginTop: {xs: "20px", md: "50px"}}}>
                    <CustomLabelMediumBold text={"Discuss Your Project with #1 Software Development Company USA "} color={"#5E17EB"}/>
                </Grid>

                <Grid item container xs={10} style={{marginTop: "5px"}} justifyContent={"center"}>
                    <CustomLabelMediumRegular normal={false}
                                              text={"Got an Idea? Let’s Build It Together — Contact Us for Expert Development Solutions.  "}
                    />
                </Grid>


                <Grid item container xs={12} justifyContent={"space-between"}
                      sx={{padding: {xs: "0px 10px", md: "0px 40px"}, marginTop: {xs: "20px", lg: "60px"}}}>


                    <Grid item xs={12} lg={4.8}
                          sx={{maxHeight: "100%", width: "100%", padding: "0px", position: "relative"}}>
                        <Box component={"img"} src={IPHONE151} alt={"OSTRYX"}
                             sx={{height: {lg: "100%"}, width: {xs: "100%", lg: "100%", xlg: "auto"}}}/>
                    </Grid>

                    <ContactUs setShowConfirmation={setShowConfirmation}/>


                </Grid>

                <div ref={contactUsRef} tabIndex={0}></div>

            </Grid>


            <Footer/>
        </Grid>
    )
}

export default TermsCondition;
